import { DOCUMENT_CONTROL_PANEL_HEIGHT } from 'constants/documents';
import { MODAL_BODY_DEFAULT_OFFSETS } from 'constants/ui';

const rootStyles = {
  overflow: 'hidden',
  maxHeight: `calc(100vh - ${MODAL_BODY_DEFAULT_OFFSETS}px)`,
  '& .document_view__document_pages_wrapper': {
    maxHeight: `calc(100vh - ${DOCUMENT_CONTROL_PANEL_HEIGHT + MODAL_BODY_DEFAULT_OFFSETS}px)`,
  },
  '& .document_view__document_slide': {
    maxHeight: `calc(100vh - ${DOCUMENT_CONTROL_PANEL_HEIGHT + MODAL_BODY_DEFAULT_OFFSETS}px)`,
  },
};

export const getStyles = () => ({
  root: rootStyles,
});
